export default "__VITE_ASSET__2f496e22__"